import { useEffect } from "react";

interface PrivacyModalProps {
  open: boolean;
  onClose: () => void;
}

export default function PrivacyModal({ open, onClose }: PrivacyModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[95] flex items-end justify-center sm:items-center"
      role="dialog"
      aria-modal="true"
      aria-label="Política de privacidade"
    >
      <button
        type="button"
        aria-label="Fechar política de privacidade"
        onClick={onClose}
        className="absolute inset-0 h-full w-full cursor-pointer bg-foreground-950/50 backdrop-blur-[3px]"
      />
      <div className="ab-modal-in relative z-10 flex max-h-[90vh] w-full flex-col overflow-hidden rounded-t-2xl bg-background-50 sm:mx-4 sm:max-w-2xl sm:rounded-lg">
        <header className="flex items-start justify-between gap-4 border-b border-background-200 px-5 py-4 md:px-7">
          <div>
            <h3 className="font-heading text-2xl text-foreground-900">Política de privacidade</h3>
            <p className="mt-1 text-xs text-foreground-600 md:text-sm">
              Como cuidamos dos seus dados neste modelo demonstrativo.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar"
            className="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-2xl" />
          </button>
        </header>

        <div className="flex-1 overflow-y-auto px-5 py-5 md:px-7">
          <div className="flex flex-col gap-5 text-sm leading-relaxed text-foreground-700">
            <div>
              <h4 className="font-heading text-lg text-foreground-900">Quais dados pedimos</h4>
              <p className="mt-1.5">
                Para organizar o seu pedido pedimos nome, WhatsApp, cidade, estado, forma de
                recebimento e, quando escolher entrega, o endereço completo. E-mail e observações são
                opcionais.
              </p>
            </div>
            <div>
              <h4 className="font-heading text-lg text-foreground-900">Para que usamos</h4>
              <p className="mt-1.5">
                Usamos essas informações apenas para atender, confirmar e acompanhar este pedido,
                combinar a entrega ou retirada e orientar o pagamento no atendimento.
              </p>
            </div>
            <div>
              <h4 className="font-heading text-lg text-foreground-900">Onde ficam os dados</h4>
              <p className="mt-1.5">
                Este site é um modelo demonstrativo. Nesta etapa, a ficha do cliente e o pedido ficam
                salvos somente no seu próprio navegador. Nada é enviado para um servidor e ninguém
                além de você acessa esses dados localmente.
              </p>
            </div>
            <div>
              <h4 className="font-heading text-lg text-foreground-900">Compartilhamento</h4>
              <p className="mt-1.5">
                Não compartilhamos seus dados com terceiros e não usamos as informações para
                finalidades diferentes do atendimento do pedido.
              </p>
            </div>
            <div>
              <h4 className="font-heading text-lg text-foreground-900">Seus direitos</h4>
              <p className="mt-1.5">
                Você pode solicitar a correção ou a exclusão dos seus dados quando quiser. Basta falar
                com a gente pelo atendimento.
              </p>
            </div>
            <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-4 text-xs text-foreground-700">
              <p className="font-medium text-foreground-900">Contato no piloto demonstrativo</p>
              <p className="mt-1">
                Vellora Studio — atendimento pelo WhatsApp neste piloto demonstrativo. Este modelo é
                uma demonstração comercial e não representa uma loja real em funcionamento.
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="mt-6 inline-flex w-full cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
}